import React from "react";

export default function BookShelf({ books, loading, onReturnBook }) {
    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">
                Book Shelf ({books.length})
            </h2>

            {loading ? (
                <p className="text-sm text-gray-500">
                    Loading bookshelf…
                </p>
            ) : books.length === 0 ? (
                <p className="text-sm text-gray-500">
                    No books currently issued.
                </p>
            ) : (
                <div className="flex gap-4 overflow-x-auto pb-2">
                    {books.map(book => (
                        <div
                            key={book.id}
                            className="w-32 flex-shrink-0 text-center"
                        >
                            <img
                                src={book.img}
                                alt={book.title}
                                className="w-32 h-40 object-cover rounded-md shadow"
                            />

                            <h3 className="text-sm font-medium truncate mt-2">
                                {book.title}
                            </h3>

                            <p className="text-xs text-gray-500">
                                {book.status}
                            </p>

                            <button
                                onClick={() =>
                                    book.status === "Reading" &&
                                    onReturnBook?.(book)
                                }
                                className={`mt-2 w-full text-sm py-1.5 rounded-md ${book.status === "In Cart" || !onReturnBook
                                    ? "bg-gray-100 text-gray-400 cursor-not-allowed border border-dashed border-gray-200"
                                    : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                                    }`}
                                disabled={book.status === "In Cart" || !onReturnBook}
                            >
                                {book.status === "In Cart"
                                    ? "In Cart"
                                    : !onReturnBook
                                        ? "Scan to Return"
                                        : "Return"}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
